<script lang="ts">
  import * as H from "../settings/hints.ts";
  import { app } from "../lib/store.svelte.ts";
  import { NetworkError } from "../lib/api.ts";

  let name = $state("Costco split");
  let busy = $state(false);
  let error = $state("");

  async function create(e: SubmitEvent) {
    e.preventDefault();
    busy = true;
    error = "";
    try {
      await app.createGroup(name.trim());
    } catch (err) {
      error = err instanceof NetworkError ? "Creating a group needs a connection. Try again when you're online." : (err as Error).message;
    } finally {
      busy = false;
    }
  }
</script>

<div class="screen">
  <form class="card" onsubmit={create}>
    <h1>Start a group</h1>
    {#if H.WELCOME_NOTE.trim()}<p class="muted">{H.WELCOME_NOTE}</p>{/if}
    <label class="field"><span>Group name</span><input class="input" bind:value={name} /></label>
    <button class="btn primary" disabled={busy || !name.trim()}>Create group</button>
    {#if error}<p class="owes" role="alert">{error}</p>{/if}
  </form>
</div>

<style>
  .screen {
    min-height: 100vh;
    display: grid;
    place-items: center;
    padding: 24px var(--gutter);
  }

  .card {
    width: min(440px, 100%);
    display: grid;
    gap: 14px;
  }
</style>
